import React from "react";
import HotelProfileMockupPage from "../../features/hotelProfileMockup/HotelProfileMockupPage";

/** Design mockup בלבד — פרופיל מלון + בחירת חדרים, ללא API. */
export default function HotelProfileMockupStandalonePage() {
  return <HotelProfileMockupPage />;
}
